/**
 * Internal Dependencies
 */
const metadata = {
  name: "date",
  supports: {
    editable: true,
    required: true,
    attachment: true,
    description: true,
    logic: false,
    theme: true
  },
  attributes: {
    format: {
      type: "string",
      "enum": ["MMDDYYYY", "DDMMYYYY", "YYYYMMDD"],
      "default": "MMDDYYYY"
    },
    separator: {
      type: "string",
      "enum": ["/", "-", "."],
      "default": "/"
    }
  }
};
const {
  name
} = metadata;
export { name, metadata };
//# sourceMappingURL=index.js.map